import React, { useState } from 'react';
import { Alert } from 'react-bootstrap';
import { useAuthentication } from '../authentiction';

const LicenseNotification: React.FC = () => {
  const { licenseHasExpired, hasValidLicense } = useAuthentication();
  const [show, setShow] = useState<boolean>(true);

  if (!show || (hasValidLicense && !licenseHasExpired)) return null;

  return (
    <Alert
      className="m-3"
      variant="warning"
      dismissible
      onClose={() => setShow(false)}
    >
      <Alert.Heading>
        {hasValidLicense ? 'Your license has expired' : 'Invalid license'}
      </Alert.Heading>
      Visitors and reception will be unable to login
    </Alert>
  );
};

export default LicenseNotification;
